import React from 'react';
import { Variant } from 'shared/types/product';
import useClassNames from 'helpers/hooks/useClassNames';
import { useFormat } from 'helpers/hooks/useFormat';

interface Props {
  variant?: Variant;
  className?: string;
}

const ItemDiscontinued: React.FC<React.PropsWithChildren<Props>> = ({ className }) => {
  const { formatMessage: formatProductMessage } = useFormat({ name: 'product' });

  const classNames = useClassNames([
    'flex h-[25px] w-fit items-center justify-center py-4 px-8 text-12 bg-ag_color-error text-white',
    className,
  ]);

  return (
    <span className={classNames}>
      {formatProductMessage({
        id: 'item.discontinued',
        defaultMessage: 'This item is no longer available',
      })}
    </span>
  );
};

export default ItemDiscontinued;
